export enum Language {
    en = 'en', // English
    es = 'es', // Spanish
}